export const LS_ORDERS_APP = 'my_orders_app';
export const LS_ORDERS_STATUS = 'my_orders_status';
export const LS_ORDERS_DATE_START = 'my_orders_date_start';
export const LS_ORDERS_DATE_STOP = 'my_orders_date_stop';
export const LS_ORDERS_COLUMNS_SETTINGS = 'my_orders_columns';